<div class="vc-admin-table-actions" [class.vc-admin-table-actions--compact]="compact">
  @if (showManage) {
    @if (manageRouterLink) {
      <a
        pButton
        class="p-button-text p-button-sm vc-admin-table-actions__manage"
        [routerLink]="manageRouterLink"
        [queryParams]="manageQueryParams"
      >
        <i class="fas fa-gear"></i>
        <span>{{ manageLabelKey | translate }}</span>
      </a>
    } @else {
      <button
        pButton
        type="button"
        class="p-button-text p-button-sm vc-admin-table-actions__manage"
        [disabled]="manageDisabled"
        [loading]="manageLoading"
        (click)="manage.emit()"
      >
        <i class="fas fa-gear"></i>
        <span>{{ manageLabelKey | translate }}</span>
      </button>
    }
  }

  @if (showDelete) {
    <button
      pButton
      type="button"
      class="p-button-text p-button-danger p-button-sm vc-admin-table-actions__delete"
      [disabled]="deleteDisabled"
      (click)="delete.emit()"
    >
      <i class="fas fa-trash"></i>
      <span>{{ deleteLabelKey | translate }}</span>
    </button>
  }
</div>
